import { getBlocks, isBlocked } from '@tymbe/utils/company-blocked-user';
import { GroupBase } from 'react-select';
import { SelectComponents } from 'react-select/dist/declarations/src/components';

import {
  InvitationSelectContainer,
  InvitationSelectControl,
  InvitationSelectInput,
  InvitationSelectMenu,
  InvitationSelectMenuList,
  InvitationSelectMultiValue,
  InvitationSelectNoOptionsMessage,
  InvitationSelectOption,
} from './TySelectInvitationCustomComponents';
import {
  OwnProps,
  TySelectInvitationOptionData,
  TySelectInvitationQueryConfig,
} from './TySelectInvitationTypes';
import {
  loadPersonOptions,
  renderOptionLabel,
} from './TySelectInvitationUtils';
import { TyAsyncSelectProps } from '../../../../../components/inputs/TyAsyncSelect';
import { PersonData } from '@tymbe/schema/person.interface';
import TyAsyncSelectInvitations from './TyAsyncSelectInvitations';
import ModalShell from '../../../../../components/modals/ModalShell';
import { useState } from 'react';

const invitationCustomSelectComponents: Partial<
  SelectComponents<PersonData, boolean, GroupBase<PersonData>>
> = {
  MultiValue: InvitationSelectMultiValue,
  Menu: InvitationSelectMenu,
  Option: InvitationSelectOption,
  Input: InvitationSelectInput,
  SelectContainer: InvitationSelectContainer,
  Control: InvitationSelectControl,
  NoOptionsMessage: InvitationSelectNoOptionsMessage,
  MenuList: InvitationSelectMenuList,
  DropdownIndicator: () => null,
  IndicatorSeparator: () => null,
};

const TySelectInvitations = <Fields extends object>(
  props: Omit<
    TyAsyncSelectProps<
      Fields,
      PersonData,
      GroupBase<PersonData>,
      void,
      boolean
    > &
      OwnProps,
    'loadOptions'
  >
) => {
  const [showErrorModal, setShowErrorModal] = useState<string|null>(null);

  const queryConfig: TySelectInvitationQueryConfig = {
    companyId: { ...props }.companyId,
    branchOfficeId: { ...props }.branchOfficeId,
    onlyInvitable: { ...props }.onlyInvitable,
    filter: { ...props }.filter,
    exclude: { ...props }.exclude,
    limitToRelatedCompanies: { ...props }.limitToRelatedCompanies,
    shiftPerks: { ...props }.shiftPerks,
  };

  const isOptionDisabled = (option: PersonData) =>
    isBlocked(
      getBlocks(option.blockedCompany, {
        id: props?.companyId,
        branchoffice: props?.branchOfficeId,
        department: props?.departmentId,
      })
    ) || option.activeBan !== null;

  return (
    <>
      <TyAsyncSelectInvitations
        key={`${props?.companyId}-${props?.branchOfficeId}-${props?.departmentId}-${props?.shiftPerks}`}
        {...props}
        debounceTimeout={1000}
        loadOptions={loadPersonOptions(queryConfig)}
        getOptionLabel={(option) =>
          renderOptionLabel(
            {
              ...option,
              onBanUserClick: (name) => setShowErrorModal(name),
            } as TySelectInvitationOptionData,
            {
              // quick fix of types
              id: props?.companyId,
              branchoffice: props?.branchOfficeId,
              department: props?.departmentId,
            }
          ) as unknown as string
        } // quick fix of types
        isOptionDisabled={isOptionDisabled}
        defaultMenuIsOpen={
          props.defaultMenuIsOpen || props.defaultMenuIsOpen === false
            ? props.defaultMenuIsOpen
            : !!props?.departmentId
        }
        customSelectComponents={invitationCustomSelectComponents}
        getOptionValue={(option) => String(option.id)}
      />

      <ModalShell showModal={!!showErrorModal} onClose={() => setShowErrorModal(null)}>
        <div className="flex flex-col gap-10 justify-between items-center">
          <h2 className='text-heading-4-md'> Uživatele {showErrorModal} není možné pozvat z důvodu banu nebo blokace </h2>
          <div className="self-end">
            <button
              type="button"
              className="ty-button-secondary"
              onClick={() => setShowErrorModal(false)}
            >
              Zavřít
            </button>
          </div>
        </div>
      </ModalShell>
    </>
  );
};

export default TySelectInvitations;
